import React from 'react';
import { matchPath, Route, Routes, useLocation } from 'react-router-dom';
import App from './App';
import PublicSharedPlaylist from './pages/shared/Playlist';

// Public shares must not mount the app's session checks or subscription bootstrap.
export default function AppRouter() {
  const { pathname } = useLocation();
  if (matchPath('/shared/playlist/:token', pathname)) {
    return (
      <Routes>
        <Route path="/shared/playlist/:token" element={<PublicSharedPlaylist />} />
      </Routes>
    );
  }
  return <App />;
}
